let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ccHfC")).then(() => parcelRequire('9Klur'));